import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { formatRelativeTime } from '~/utils';
import { PendingOrdersColumn } from './shared/PendingOrdersColumn';

export function OrdersToConfirmColumn() {
  const { t } = useTranslation('dashboard');
  return (
    <PendingOrdersColumn
      perspective="SELLING"
      title={t('dashboard.seller_orders_to_confirm.title')}
      subtitle={t('dashboard.seller_orders_to_confirm.subtitle')}
      footerLink="/seller-orders/pending-seller-confirmation"
      footerLabel={t('dashboard.seller_orders_to_confirm.footer')}
      emptyText={t('dashboard.seller_orders_to_confirm.empty')}
      errorText={t('dashboard.seller_orders_to_confirm.error')}
      getOrgLabel={(order) => order.buyingOrganization.name}
      renderRow3Right={(order) => (
        <Link
          to={`/orders/view/${order.id}?returnPath=/dashboard`}
          className="px-2 py-0.5 rounded text-xs font-medium transition-colors bg-prim text-white hover:bg-prim-700 shrink-0"
        >
          {t('dashboard.seller_orders_to_confirm.confirm_button')}
        </Link>
      )}
      renderRow4Right={(order) => (
        <p className="text-xs font-medium text-neut-sec shrink-0">
          {formatRelativeTime(order.createdAt, t)}
        </p>
      )}
    />
  );
}
